import React from 'react';
import PropTypes from 'prop-types'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../../queue/QueuePage.scss';

const AssociatesHeaderSortLink = ({ sortKey, currentSortKey, isReversed, onClick, children }) => 
    (sortKey !== currentSortKey) ?
        <a className='sort-header-link' onClick={() => onClick(sortKey)}>
            {children}
        </a>
        :
        <div className='header-sort-link' onClick={() => onClick(sortKey)}>
            {children}
            <div className='header-direction-toggle' >
                {isReversed &&
                    <ExpandLessIcon />
                }
                {!isReversed &&
                    <ExpandMoreIcon />
                }
            </div>
        </div>

AssociatesHeaderSortLink.propTypes = {
    sortKey: PropTypes.string.isRequired,
    currentSortKey: PropTypes.string,
    isReversed: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default AssociatesHeaderSortLink